import { useTranslation } from 'react-i18next';

import { GuidedModal, GuidedModalOption } from 'src/features/guided-modal';

interface MeetAssemblyModalProps {
  isOpen: boolean;
  /** Any way out, including "Maybe later". */
  onClose: () => void;
  onScheduleKickoffCall: () => void;
  onConnectSlackChannel: () => void;
}

/** Shown once both checklists are done: a kickoff call or a shared Slack channel. */
export const MeetAssemblyModal = ({
  isOpen,
  onClose,
  onScheduleKickoffCall,
  onConnectSlackChannel,
}: MeetAssemblyModalProps) => {
  const { t } = useTranslation();

  return (
    <GuidedModal
      isOpen={isOpen}
      title={t(
        ($) => $.page_apps.app_builder.getting_started.meet_assembly.title,
      )}
      description={t(
        ($) =>
          $.page_apps.app_builder.getting_started.meet_assembly.description,
      )}
      closeLabel={t(
        ($) => $.page_apps.app_builder.getting_started.meet_assembly.close,
      )}
      onClose={onClose}
      dismissLabel={t(
        ($) =>
          $.page_apps.app_builder.getting_started.meet_assembly.maybe_later,
      )}
      onDismiss={onClose}
    >
      <div className="flex flex-col gap-1">
        <GuidedModalOption
          icon="Calendar"
          label={t(
            ($) =>
              $.page_apps.app_builder.getting_started.meet_assembly
                .kickoff_call,
          )}
          onClick={onScheduleKickoffCall}
        />
        <GuidedModalOption
          icon="Slack"
          label={t(
            ($) =>
              $.page_apps.app_builder.getting_started.meet_assembly
                .slack_channel,
          )}
          onClick={onConnectSlackChannel}
        />
      </div>
    </GuidedModal>
  );
};
